import { render, staticRenderFns } from "./_dailyWinloseByMatch.vue?vue&type=template&id=a27448e4&lang=pug&"
import script from "./_dailyWinloseByMatch.vue?vue&type=script&lang=js&"
export * from "./_dailyWinloseByMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports